import React, { PureComponent } from 'react';
import { Spin } from 'antd';
import './FullLoading.less';

class FullLoading extends PureComponent {
	render () {
		return (<div className='eh-loading-component-full'>
			<div className="eh-loading-component-full-inner">
				<Spin {...this.props} />
			</div>
		</div>);
	}
}

FullLoading.defaultProps = {
	size: 'large',
	spinning: true
};

export default FullLoading;
